  <div id="main" [ngClass]="{'shifted': isOpen, 'backdrop': isOpen}" *ngIf="admin.isAdmin()" (click)="closeSidebar($event)">
    
    <nav class="navbar navbar-expand-lg navbar-light">
      <div class="container-fluid">

        <a class="menu" (click)="toggleNav($event)" >
          <i class="fi fi-rr-bars-staggered"></i>
        </a>
       
        <ul class="nav">
           <!-- {{ admin.user.name }}
          <li class="nav-item">
            <a class="nav-link " *ngIf="currentLang !== 'ge'" (click)="switchLanguage('ge')">
              <img class="flag" src="/assets/images/ge.png" alt="ქართული" />
            </a>
            <a class="nav-link " *ngIf="currentLang !== 'en'" (click)="switchLanguage('en')">
              <img class="flag" src="/assets/images/us.png" alt="English" />
            </a>
          </li> -->

           <li class="nav-item">
            <a class="nav-link text-color" href="https://partsauto.ge/" target="_blank" ><i class="fi fi-rr-site-alt"></i></a>
          </li>

          <li class="nav-item ">
            <a class="nav-link text-color" (click)="logout()"><i class="fi fi-rr-sign-out-alt"></i></a>
          </li>
        </ul>
        

      </div>
    </nav> 

 
    <div #scrollContainer style="height: 100vh; overflow-y: auto;">
      <router-outlet></router-outlet>
    </div>

  </div>

  <div class="container-fluid" *ngIf="!admin.isAdmin()">
    <router-outlet></router-outlet>
  </div>

  <div class="sidebar" [ngClass]="{'open': isOpen}" *ngIf="admin.isAdmin()">
    <a routerLink="/">
      <img src="https://api.partsauto.ge/storage/files/logo-light.png" class="logo-sidebar ps-4"/>
    </a>


    <div class="list-group list-group-flush  ps-4 mt-2">

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"

        >
          <i class="fi fi-rr-house-chimney"></i>
          <span class="mx-1">მთავარი</span>
      </a>
     <a 
        class="list-group-item d-flex" 
        [routerLink]="['/marks']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('marks')"
        >
          <i class="fi fi-rr-brand"></i>
          <span class="mx-1">ბრენდები</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/cars']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('cars')">
          <i class="fi fi-rr-car-alt"></i>
          <span class="mx-1">მანქანები</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/parts']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()" 
        *ngIf="admin.hasPermission('parts')">
           <i class="fi fi-rr-engine"></i>
          <span class="mx-1">ნაწილები</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/news']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()" 
        *ngIf="admin.hasPermission('news')">
           <i class="fi fi-rr-newspaper"></i>
          <span class="mx-1">სიახლეები</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/slider']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('slider')">
           <i class="fi fi-rr-sliders-v"></i>
          <span class="mx-1">სლაიდი</span>
      </a>
      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/orders']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('orders')">
           <i class="fi fi-rr-box"></i>
          <span class="mx-1">შეკვეთები</span>
      </a>

      


      
      

    </div>
  </div>






